import {Settings} from "./settings";
import {biasedRandomInt, EventBatchSource, flatten, RhythmTreeGenerator} from "@measure-up/rhythm";
import {BarEvent} from "./bar-events";

/**
 * A demand-driven source of bars for the {@link Scheduler}: each call
 * generates one bar of {@link BarEvent}s. Nothing is generated until the
 * scheduler's buffer runs dry and it pulls the next batch.
 *
 * Structural settings (beatsPerBar) are read live from `settings`, so changes
 * take effect when the next bar is generated.
 */
function createBarEventSource(
    generator: RhythmTreeGenerator,
    settings: Settings,
): EventBatchSource<BarEvent> {
    return () =>
        flatten(generator.generate(), settings.beatsPerBar)
            .map((rhythmEvent, index): BarEvent =>
                ({
                    duration: rhythmEvent.duration,
                    isRest: index === 0 && settings.hasDownbeatAlways
                        ? false
                        : biasedRandomInt(0, 1, settings.spaceBias) === 1,
                    isDownbeat: index === 0,
                })
            );
}

export {createBarEventSource};
